import { parseTemplate } from 'url-template';
import { mapPagination, Pagination } from '~/Api/Pagination';
import ApiClient from '~/ApiClient';
import mapVirtualBrandAnalytics from './mapAnalyticVirtualBrand';
import { VirtualBrandAnalytics } from './mapAnalyticVirtualBrand';

import mapVirtualBrand from './mapVirtualBrand';
import Query from './Query';
import VirtualBrand from './VirtualBrand';

export interface Result {
	items: VirtualBrand[];
	pagination: Pagination;
}

export default async function findVirtualBrands(
	client: ApiClient,
	query: Query,
	page: number,
	perPage: number
): Promise<Result> {
	const parameters = query.filterParameters.reduce(
		(parameters: { [key: string]: number | string | null }, parameter) => {
			parameters[`filter-${parameter.name}`] =
				typeof parameter.value === 'string' ? parameter.value : Array.from(parameter.value).join(',');
			return parameters;
		},
		{
			currency: query.currency == 'source' ? null : query.currency,
			page,
			perPage,
		}
	);

	const therapeuticAreaFilter = query.filterParameters.find((parameter) => parameter.name === 'therapeutic-area');
	const therapeuticAreaUrlPart =
		therapeuticAreaFilter !== undefined && therapeuticAreaFilter.value instanceof Array
			? therapeuticAreaFilter.value.map((value) => `&filter-therapeutic-area=${encodeURIComponent(value)}`).join('')
			: '';

	const url = parseTemplate('analytics/virtual-brands{?filter-brand,filter-atc,currency,page,perPage}');
	const request = await client.fetch(url.expand(parameters) + therapeuticAreaUrlPart);
	const response = await request.json();
	return {
		items: response.items.map(mapVirtualBrand),
		pagination: mapPagination(response.pagination),
	};
}

export async function fetchAnalyticsOfVirtualBrand(
	client: ApiClient,
	virtualBrandId: string
): Promise<VirtualBrandAnalytics> {
	const url = parseTemplate('analytics/virtual-brands/{virtualBrandId}/availability');
	const request = await client.fetch(url.expand({ virtualBrandId }));
	const response = await request.json();
	return mapVirtualBrandAnalytics(response.virtualBrand);
}

export async function fetchVirtualBrand(client: ApiClient, virtualBrandId: string): Promise<VirtualBrand> {
	const url = parseTemplate('analytics/virtual-brands/{virtualBrandId}');
	const request = await client.fetch(url.expand({ virtualBrandId }));
	const response = await request.json();
	return mapVirtualBrand(response.virtualBrand);
}
